module.exports = (__parcel__import__("jT8Xv")).then(() => parcelRequire('GLD9c'));